export const REDUCER_NAME = 'search'

export const APPOINTMENT_TYPE = [
    {
        id: 'scan',
        value: 'scan',
    },
    {
        id: 'ipr',
        value: 'ipr',
    },
    {
        id: '3d-implant-scan',
        value: '3d-implant-scan',
    },
    {
        id: 'implant-surgery',
        value: 'implant-surgery',
    },
]



// WEBPACK FOOTER //
// ./src/modules/appointment/state/search/const.js